import React from 'react';
import Loadable from 'react-loadable';
import glamorous from 'glamorous';
import { Spinner } from '@blueprintjs/core';
import { connect } from 'react-redux';
import { reduce, get } from 'lodash';
import { compose } from 'recompose';
import { getLocale, getAvailableLocales, getConfig } from '../../selectors'

const LoadingIndicator = (props) => (
  <glamorous.Div className="container" css={{ textAlign: 'center' }}>
    <Spinner/>
  </glamorous.Div>
);

export const getLoadables = (page) => reduce(getAvailableLocales(), (agg, item, key) => {
  agg[key] = Loadable({
    loader: () => import(`./${key}/${page}`),
    loading: LoadingIndicator,
  });
  return agg;
}, {});

const LocalizedStatic = ({ loadables, locale, config }) => {
  const Localized = get(loadables, locale);
  return <Localized config={config}/>;
};

export default compose(
  connect(state => ({
    locale: getLocale(),
    config: getConfig(state),
  }), {}),
)(LocalizedStatic);



// WEBPACK FOOTER //
// ./src/views/static/static-utils.js